export const REQUEST_STARTINTERVIEW = 'REQUEST_STARTINTERVIEW';
export const STARTINTERVIEW_RECEIVED = 'STARTINTERVIEW_RECEIVED';
export const SEND_PARTICIPANTS_LIST_ONSTART = 'SEND_PARTICIPANTS_LIST_ONSTART';
export const SEND_PARTICIPANTS_LIST_RECIEVED_ONSTART = 'SEND_PARTICIPANTS_LIST_RECIEVED_ONSTART';
export const REQUEST_UPDATELAYOUT = 'REQUEST_UPDATELAYOUT';
export const UPDATELAYOUT_RECIEVED = 'UPDATELAYOUT_RECIEVED';
